import React from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import { Table } from "../view/Table";
import RecipientTableRow from "./RecicpientTableRow";
import RecipientTableRowSkeleton from "./RecipientTableRowSkeleton";
import { TableContext } from "../index";

function RecipientTable({ users }) {
    const { config } = React.useContext(TableContext);

    const headers = [
        { name: 'USERNAME', onClick: () => { } },
        { name: 'FIRST NAME', onClick: () => { } },
        { name: 'LAST NAME', onClick: () => { } },
        { name: 'EMAIL', onClick: () => { } },
        { name: 'ENABLE ALERTING', onClick: () => { } }
    ]

    return (
        <Table headers={headers} elements={users} containsEditButton={false} className="mt-2">
            {config.isLoading ? (
                Array.from(new Array(4)).map((_, index) => (
                    <RecipientTableRowSkeleton key={index} index={index} />
                ))
            ) : (
                users.map((users, index) => <RecipientTableRow key={index} data={users} index={index} />)
            )}
        </Table>
    )

}

function mapStateToProps(state) {
    debug("RecipientTable mapStateToProps", state);
    const page = state.alertPage;
    return {
        users: page.users || []
    };
}


export default connect(mapStateToProps)(RecipientTable);